export default __webpack_public_path__ + "static/media/react.ae9c5b34.png";